import React from 'react';

import { Field, Formik } from 'formik';
import isEqual from 'lodash/isEqual';
import size from 'lodash/size';
import { connect } from 'react-redux';

import { Divider } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

import initialValues from './initialValues';
import validate from './validate';

import MoneyTextField from '../../components/MoneyTextField';
import ScreenWrapper from '../../components/ScreenWrapper';
import SelectField from '../../components/SelectField';
import TotalAssets from '../../components/TotalAssets';
import TotalDebt from '../../components/TotalDebt';
import TotalNetWorth from '../../components/TotalNetWorth';

import { PAGES } from '../../config/constants';
import { citizenship } from '../../constants/citizenship';
import { BORROWER } from '../../constants/contact_id_status';
import { creditScore } from '../../constants/creditScore';
import { experience } from '../../constants/experience';
import experience_lifetime_list from '../../constants/experience_lifetime_list';
import { foreclosures } from '../../constants/foreclosures';
import { yes_no } from '../../constants/yes_no';

import { saveContact } from '../../actions/saveContact.actions';

const BorrowerCredit = ({ setBorrowerCredit, borrowerInfo, setNext, setPrevPage, id_status }) => {
  const formControlStyle = {
    formControlStyle: { style: { marginTop: 10 } },
  };

  const checkSubmit = (values, handleSubmit) => {
    const errors = validate(values);

    if (size(errors) === 0) {
      handleSubmit();
    }
  };

  return (
    <React.Fragment>
      <h1
        style={{
          textAlign: 'center',
          fontSize: '60px',
          fontStyle: 'normal',
          fontWeight: 600,
          marginTop: -10,
          marginBottom: 30,
        }}
      >
        Asset, Liabilities & Credit
      </h1>

      <ScreenWrapper fullWidth step={5}>
        <Formik
          initialValues={initialValues()}
          onSubmit={values => {
            if (isEqual(borrowerInfo, values)) {
              setNext();
            } else {
              setBorrowerCredit(values);
            }
          }}
          validate={validate}
        >
          {({ handleSubmit, values }) => (
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <Typography
                    style={{
                      marginTop: 10,
                      marginBottom: 10,
                      textAlign: 'center',
                      fontSize: '20px',
                      fontWeight: 'bold',
                      color: '#2c3e4d',
                    }}
                  >
                    Please enter your assets balance for each account.
                  </Typography>
                </div>

                <div className="col-md-6">
                  <Field
                    name="checking_1_b"
                    component={MoneyTextField}
                    label="Checking Account (s)"
                    required
                    {...formControlStyle}
                  />

                  <Field
                    name="checking_2_b"
                    component={MoneyTextField}
                    label="Savings / Money Market / CD's"
                    required
                    {...formControlStyle}
                  />

                  <Field
                    name="savings_1_b"
                    component={MoneyTextField}
                    label="Stocks / Bonds"
                    required
                    {...formControlStyle}
                  />

                  <Field
                    name="savings_2_b"
                    component={MoneyTextField}
                    label="IRA / Bonds"
                    required
                    {...formControlStyle}
                  />
                </div>
                <div className="col-md-6">
                  <Field
                    name="stocks_bonds_1_b"
                    component={MoneyTextField}
                    label="401K / Keogh Accounts"
                    required
                    {...formControlStyle}
                  />

                  <Field
                    name="stocks_bonds_2_b"
                    component={MoneyTextField}
                    label="401K / ESOP Accounts"
                    required
                    {...formControlStyle}
                  />

                  <Field
                    name="retirement_1_b"
                    component={MoneyTextField}
                    label="Availability under lines of Credit"
                    required
                    {...formControlStyle}
                  />

                  <Field
                    name="retirement_2_b"
                    component={MoneyTextField}
                    label="Primary Residence"
                    required
                    {...formControlStyle}
                  />

                  <Field
                    name="other_real_estate_b"
                    component={MoneyTextField}
                    label="Other Real Estate"
                    required
                    {...formControlStyle}
                  />
                </div>

                <div className="col-md-12">
                  <TotalAssets values={values} />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <Divider style={{ marginTop: 20, backgroundColor: 'rgb(44, 62, 77)' }} />

                  <Typography
                    style={{
                      marginTop: 10,
                      marginBottom: 10,
                      textAlign: 'center',
                      fontSize: '20px',
                      fontWeight: 'bold',
                      color: '#2c3e4d',
                    }}
                  >
                    Please enter your liabilities for each account.
                  </Typography>
                </div>

                <div className="col-md-6">
                  <Field
                    name="owed_primary_residence_b"
                    component={MoneyTextField}
                    label="Primary Residence"
                    required
                    {...formControlStyle}
                  />
                </div>

                <div className="col-md-6">
                  <Field
                    name="owed_other_real_estate_b"
                    component={MoneyTextField}
                    label="Other Real Estate"
                    required
                    {...formControlStyle}
                  />
                </div>

                <div className="col-md-12">
                  <TotalDebt values={values} />

                  <Divider
                    style={{ marginTop: 20, marginBottom: 10, backgroundColor: 'rgb(44, 62, 77)' }}
                  />

                  <TotalNetWorth values={values} />
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <Divider style={{ marginTop: 20, backgroundColor: 'rgb(44, 62, 77)' }} />

                  <Typography
                    style={{
                      marginTop: 10,
                      marginBottom: 10,
                      textAlign: 'center',
                      fontSize: '20px',
                      fontWeight: 'bold',
                      color: '#2c3e4d',
                    }}
                  >
                    Credit
                  </Typography>
                </div>
              </div>

              <div className="row" style={{ marginTop: 15 }}>
                <div className="col-md-6">
                  <Field
                    name="us_citizen"
                    component={SelectField}
                    label="Citizenship *"
                    options={citizenship}
                    required
                    cstmOnChange={async vals => {
                      await Promise.resolve();

                      setTimeout(() => {
                        checkSubmit(vals, handleSubmit);
                      }, 100);
                    }}
                  />

                  <Field
                    name="non_entity_borrower"
                    component={SelectField}
                    label="Non-Entity Borrower *"
                    options={yes_no}
                    required
                    {...formControlStyle}
                    cstmOnChange={async vals => {
                      await Promise.resolve();

                      setTimeout(() => {
                        checkSubmit(vals, handleSubmit);
                      }, 100);
                    }}
                  />

                  <Field
                    name="experience"
                    component={SelectField}
                    label="# of flips completed in the past 2 years ? *"
                    options={experience}
                    required
                    {...formControlStyle}
                    cstmOnChange={async vals => {
                      await Promise.resolve();

                      setTimeout(() => {
                        checkSubmit(vals, handleSubmit);
                      }, 100);
                    }}
                  />

                  <Field
                    name="experience_lifetime"
                    component={SelectField}
                    label="# of Flips/Rental Purchased Lifetime *"
                    options={experience_lifetime_list}
                    required
                    {...formControlStyle}
                    cstmOnChange={async vals => {
                      await Promise.resolve();

                      setTimeout(() => {
                        checkSubmit(vals, handleSubmit);
                      }, 100);
                    }}
                  />
                </div>

                <div className="col-md-6">
                  <Field
                    name="credit_cstm"
                    component={SelectField}
                    label="Credit Score *"
                    options={creditScore}
                    required
                    cstmOnChange={async vals => {
                      await Promise.resolve();

                      setTimeout(() => {
                        checkSubmit(vals, handleSubmit);
                      }, 100);
                    }}
                  />

                  <Field
                    name="foreclosure"
                    component={SelectField}
                    label="Foreclosure *"
                    options={foreclosures}
                    required
                    {...formControlStyle}
                    cstmOnChange={async vals => {
                      await Promise.resolve();

                      setTimeout(() => {
                        checkSubmit(vals, handleSubmit);
                      }, 100);
                    }}
                  />

                  <Field
                    name="bankruptcy"
                    component={SelectField}
                    label="Bankruptcy *"
                    options={foreclosures}
                    required
                    {...formControlStyle}
                    cstmOnChange={async vals => {
                      await Promise.resolve();

                      setTimeout(() => {
                        checkSubmit(vals, handleSubmit);
                      }, 100);
                    }}
                  />
                </div>
              </div>

              <div style={{ marginTop: 10 }}>
                {id_status !== BORROWER.value && (
                  <div style={{ float: 'left' }}>
                    <button type="button" className="cstm_btn cstm_btn-text" onClick={setPrevPage}>
                      Back
                    </button>
                  </div>
                )}

                <div style={{ float: 'right' }}>
                  <button type="button" className="cstm_btn cstm_btn-blue" onClick={handleSubmit}>
                    Next
                  </button>
                </div>
              </div>
            </div>
          )}
        </Formik>
      </ScreenWrapper>
    </React.Fragment>
  );
};

const mapState = state => {
  return {
    borrowerInfo: state.borrowerInfo,
    id_status: state.form.contacts.id_status,
  };
};

const mapDispatch = dispatch => {
  return {
    setBorrowerCredit: values => {
      dispatch({
        type: 'SET_BORROWER_INFO',
        payload: values,
      });

      dispatch(saveContact());
    },

    setPrevPage: () => {
      dispatch({
        type: 'SET_PAGE',
        payload: PAGES.BORROWER_INFO2,
      });
    },

    setNext: () => {
      dispatch({
        type: 'SET_PAGE',
        payload: PAGES.PROPERTY_ADDRESS,
      });
    },
  };
};

export default connect(mapState, mapDispatch)(BorrowerCredit);



// WEBPACK FOOTER //
// ./src/Screens/BorrowerCredit/index.js